module.exports = __webpack_public_path__ + "static/media/templates.2e58e01c.svg";